import { render, staticRenderFns } from "./KA_homePage.vue?vue&type=template&id=8b98f3e6&scoped=true&"
import script from "./KA_homePage.vue?vue&type=script&lang=js&"
export * from "./KA_homePage.vue?vue&type=script&lang=js&"
import style0 from "./KA_homePage.vue?vue&type=style&index=0&id=8b98f3e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b98f3e6",
  null
  
)

export default component.exports